export const PRICING = {
  currency: "EUR",

  // AKTUELLER PREIS (Aktionspreis — Rabatt wird via Stripe-Promo-Code abgezogen)
  price: 19.9,

  // ALTER PREIS (Streichpreis)
  oldPrice: 99,

  // Promo-Code, der automatisch an den Stripe-Checkout übergeben wird,
  // damit ALLE den Aktionspreis zahlen (ohne Code-Eingabe).
  // WICHTIG: Der zugehörige Stripe-Coupon muss 79,10 € Rabatt geben
  // (99 € − 79,10 € = 19,90 €) — NICHT "19,90 € Rabatt".
  promoCode: "TheShowMustGoOn",

  // PAYMENT LINK
  paymentLink: "https://buy.stripe.com/28EcN6a241om8LpgJ8bEA00",
};

// Preis im deutschen Format ("19,90 €" / "99 €") — zentral, damit alle
// Anzeigen (Premium-Seite, Dialoge) identisch formatieren.
export const formatPrice = (value, currency = PRICING.currency) => {
  if (value == null || Number.isNaN(Number(value))) return "";
  const num = Number(value);
  const formatted = num.toLocaleString("de-DE", {
    minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${currency === "EUR" ? "€" : currency}`;
};

// Payment-Link inkl. fix hinterlegtem Promo-Code.
export const paymentUrlWithPromo = (code = PRICING.promoCode) => {
  if (!PRICING.paymentLink) return "";
  if (!code) return PRICING.paymentLink;
  try {
    const url = new URL(PRICING.paymentLink);
    url.searchParams.set("prefilled_promo_code", code);
    return url.toString();
  } catch {
    const sep = PRICING.paymentLink.includes("?") ? "&" : "?";
    return `${PRICING.paymentLink}${sep}prefilled_promo_code=${encodeURIComponent(code)}`;
  }
};
